export const sendNativeMessage = (platform, message, data = {}) => {
  const payloadObj = { ...data, message };
  const payloadStr = JSON.stringify(payloadObj);
  switch (platform.toLowerCase()) {
    case "ios":
    case "mac":
      return (window.location = `emitmessage://${encodeURIComponent(
        payloadStr
      )}`);
    case "android":
      return window.Android.emitMessage(payloadStr);
    case "windows":
      if (window.chrome !== undefined && window.chrome.webview !== undefined) {
        return window.chrome.webview.postMessage(payloadObj);
      } else {
        // This is a microsoft-specific thang
        return window.external.notify(payloadStr);
      }
    case "web":
      return window.parent.postMessage(payloadObj, window.location.origin);
    default:
      return alert("What platform is this madness?");
  }
};
